import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import PersonIcon from "@mui/icons-material/Person";
import {Link} from "react-router-dom";
import RegisterIcon from "@mui/icons-material/AppRegistration";
import Button from "@mui/material/Button";
import {CreditCardTwoTone} from "@mui/icons-material";
import {CircularProgress} from "@mui/material";
import Table from "@mui/material/Table";

export default function ListedMachinePanel({machineId}) {
    const [listedMachineId, setListedMachineId] = useState(machineId)
    const [listingComp, setListingComp] = useState([]);
    const [authToken, setAuthToken] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const token = Cookies.get('auth');
        if (token) {
            setLoading(true);
            setAuthToken(token);
            fetch(`../api/listing/getListingComp?token=${encodeURIComponent(token)}&m_id=${listedMachineId}`)
                .then(response => response.json())
                .then(data => {
                    setListingComp(data);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching machines:', error);
                    setLoading(false);
                });
        } else {
            console.log('No token present in cookies.');
        }
    }, []);
    return (

            <div className={listingComp.machineRented ? "SectionBoxEmbOrange" : "SectionBoxEmbedded"}>
                  <span className="trHeader">MACHINE ID</span>
                  <span className="SectionHeading"> {listedMachineId}</span>
                  <span className="headingInfoOrange">{listingComp.listing ? listingComp.listing.gpuName + ' x ' + listingComp.listing.numGpus : 'Loading...'}</span>
                  <div className="divLineDualGrad"></div>
                  {loading ? (
                      // Show spinner in the center when loading
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                          <CircularProgress />
                      </div>
                  ) : (
                      // Render machines list if not loading and machines are available
                      <>
                      <div className ="SectionLtrEmbedded">
                              <div className="EmbeddedBlock">
                                  <div className="trHeader">
                                      Message
                                  </div>
                                  <div className="tableData">
                                      {listingComp.tunedMessage}
                                  </div>
                              </div>
                              <div className="EmbeddedBlock">
                                  <div className="trHeader">
                                      Action
                                  </div>
                                  <div className="tableData">
                                      {listingComp.tunedAction}
                                  </div>
                              </div>

                      </div>

                          {!listingComp.machineRented ? (
                      <div className ="SectionLtrEmbedded">

                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Auto Sort Pos
                              </div>
                              <span className="TextEmphasis">
                                  {listingComp.autoSortPosMinGpu}
                              </span>
                              <span className="TextSubEmphasis">
                                    {' / '} {listingComp.autoSortSizeMinGpu}
                              </span>
                          </div>
                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Score
                              </div>
                              <div className="TextMidEmphasis">
                                  {listingComp.scoreMinGpu}
                              </div>
                          </div>

                      </div>
                          ):<></>}

                          <div className ="SectionLtrEmbedded">
                        <div>
                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Listed Price Level
                              </div>
                              <div className="TextSubEmphasis">
                                  {listingComp.listedPriceLevel}
                              </div>
                          </div>

                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Listed Price
                              </div>
                              <div className="TextSubEmphasis">
                                  ${listingComp.listedPrice}
                              </div>
                              <div className="tdGpuInfo">{`h $ ${(listingComp.listedPrice * .75).toFixed(3)}`}</div>
                          </div>
                        </div>


                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Suggested Prices
                              </div>
                              <div className="tableData">
                                  {/* Reverse the array and render suggested prices with levels */}
                                  {listingComp.suggestedPrices && [...listingComp.suggestedPrices].reverse().map((price, index, arr) => (
                                      <div key={index}>
                                          <div>L{arr.length - index}: ${price}</div>
                                          <div className="tdGpuInfo">{`h $ ${(price * .75).toFixed(3)}`}</div>
                                      </div>

                                  ))}
                              </div>
                          </div>
                              <div>
                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Tuned Price Level
                              </div>
                              <div className="TextSubEmphasis">
                                  {listingComp.tunedPriceLevel}
                              </div>
                          </div>

                          <div className="EmbeddedBlock">
                              <div className="trHeader">
                                  Tuned Price
                              </div>
                              <div className="TextSubEmphasis">
                                  ${listingComp.tunedPrice}
                              </div>
                              <div className="tdGpuInfo">{`c $ ${(listingComp.tunedPrice * (100/75)).toFixed(2)}`}</div>
                          </div>
                              </div>
                      </div>


                      </>
                  )}
              </div>

    );
}